// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .Profile-root-NP5qs {
 	padding-left: 12px;
 	padding-right: 12px;
 }

 .Profile-container-tjV1Q {
 	margin: 0 auto;
 	padding: 0 0 40px;
 	max-width: var(--max-content-width);
 }

 @media (max-width: 767px) {
 	.Profile-root-NP5qs {
 		padding-left: 0;
 		padding-right: 0;
 	}
 }`, "",{"version":3,"sources":["webpack://./src/routes/profile/Profile.css"],"names":[],"mappings":"CAAC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,iBAAiB;EACjB,mCAAmC;CACpC;;CAEA;EACC;GACC,eAAe;GACf,gBAAgB;EACjB;CACD","sourcesContent":[" .root {\n \tpadding-left: 12px;\n \tpadding-right: 12px;\n }\n\n .container {\n \tmargin: 0 auto;\n \tpadding: 0 0 40px;\n \tmax-width: var(--max-content-width);\n }\n\n @media (max-width: 767px) {\n \t.root {\n \t\tpadding-left: 0;\n \t\tpadding-right: 0;\n \t}\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Profile-root-NP5qs`,
	"container": `Profile-container-tjV1Q`
};
module.exports = ___CSS_LOADER_EXPORT___;
